import { ReactNode } from 'react';
import { DateTime } from 'luxon';
import { makeStyles } from '@material-ui/core';
import { useTranslationRef } from '@backstage/frontend-plugin-api';
import { ModernCustomCard } from '../../CustomCard';
import { catalogTranslationRef } from '../../../translation';
import { CardBody } from '@backstage/ui';

const useStyles = makeStyles({
  gridItemCardContent: {
    flex: 1,
  },
});

export interface BaseOverviewCardProps {
  children?: ReactNode;
  actions?: false | JSX.Element;
}

export function BaseOverviewCard(props: Readonly<BaseOverviewCardProps>) {
  const { children, actions = false } = props;
  const classes = useStyles();
  const { t } = useTranslationRef(catalogTranslationRef);

  return (
    <ModernCustomCard title={t('overviewCard.title')} actions={actions}>
      <CardBody className={classes.gridItemCardContent}>{children}</CardBody>
    </ModernCustomCard>
  );
}

export function convertDateFormat(
  dateStr: string | undefined,
): string | undefined {
  if (!dateStr) {
    return dateStr;
  }

  try {
    const parsedDate = DateTime.fromISO(dateStr);
    return parsedDate.toFormat('MMMM d, yyyy – HH:mm:ss');
  } catch (error) {
    return undefined;
  }
}
